'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { noTooltipInternal } from '../icon-button/icon-button-internal.utils.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';
import { useModalDialogContext } from './modal-dialog.context.js';
import { IconButton } from '../icon-button/icon-button.component.js';
import { Icon } from '../icon/icon.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';
import { className } from '../../../core/utilities/classnames.utils.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)r = c[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)r = c[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const ModalDialogCloseButton = renderWithRef('ModalDialogCloseButton', null, (r, u)=>{
    useDeprecatedProps('ModalDialogCloseButton', r, [
        {
            propName: 'visuallyHiddenLabel',
            instructions: 'Use `accessibleText` instead'
        }
    ]);
    let { handleModalCloseButton: b } = useModalDialogContext(), { visuallyHiddenLabel: m, accessibleText: f, onClick: d, className: y, children: _ } = r, j = _object_without_properties(r, [
        "visuallyHiddenLabel",
        "accessibleText",
        "onClick",
        "className",
        "children"
    ]), O = null != f ? f : m;
    return jsxs(IconButton, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
        skin: "tertiary",
        className: className('swan-modal-dialog-close-button', y),
        ref: u
    }, j), {
        onClick: composeEventHandlersUtil(d, b),
        tooltip: ""
    }), noTooltipInternal), {
        children: [
            null !== O ? jsx(VisuallyHidden, {
                children: O
            }) : null,
            jsx(Icon, {
                iconType: "close",
                size: "standard"
            })
        ]
    }));
});

export { ModalDialogCloseButton };
